import {
  GoogleGlobalSiteTagPageEventCommand,
  GoogleGlobalSiteTagPageSetCommand,
} from 'backend';
import {
  EXTERNAL_MEASUREMENT_TAG_TYPE,
  MeasurementSettingHandledByGtag,
} from '../models';

type CommandValues =
  | GoogleGlobalSiteTagPageSetCommand['parameterValues']
  | Required<GoogleGlobalSiteTagPageEventCommand>['eventParameterValues'];

export const createWithSendTo =
  (id: string) =>
  (commandValues: CommandValues): CommandValues => ({
    ...commandValues,
    send_to: id,
  });

export const getId = (setting?: MeasurementSettingHandledByGtag): string => {
  if (!setting) {
    return '';
  }
  switch (setting.type) {
    case EXTERNAL_MEASUREMENT_TAG_TYPE.GoogleAnalytics4:
      return setting.measurementId;
    case EXTERNAL_MEASUREMENT_TAG_TYPE.UniversalAnalytics:
      return setting.trackingId;
  }
};
